import React from 'react';
import { Box, Card } from '@edreamsodigeo/prisma-design-system';
import { Desktop, Mobile, createFeature } from '@edreamsodigeo/frontend-core';
import { Header } from './PaxForm.header';
import { PrimeAcquisitionForm } from '@/components/SummaryContactDetails/PrimeAcquisitionForm';
import { RecognizeUserForm } from '@/components/SummaryContactDetails/RecognizeUserForm';
import { AlertBox, FIELDS } from '@/components/SummaryContactDetails/formUtils';
import { PRIME_FIRST_PHASE_2_DESKTOP } from '@/versionedComponents';
import { useLogin } from '@/providers/login/LoginProvider';
import { InformativeAlertPhase } from '@/components/SummaryContactDetails/Alerts';

const VersionedFormDesktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [RecognizeUserForm, PrimeAcquisitionForm, PrimeAcquisitionForm],
  version: 1,
});

const VersionedAlertBoxDesktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [AlertBox, InformativeAlertPhase, InformativeAlertPhase],
  version: 1,
});

export const SummaryContactDetails = ({
  data,
  onBlur,
  showErrors,
  isActive,
  userEmail,
  isActiveLoading,
  disabledEmail,
  formFields = FIELDS,
}) => {
  const { isLogged } = useLogin();
  const showCriticalAlert =
    formFields.EMAIL.validation(userEmail) && !isActive && !isActiveLoading;

  return (
    <Box px="base" pb="1x_big" pt="2x_small">
      <Card p="small" pb="1x_big">
        <Header />

        {!isLogged && (
          <>
            <Mobile>
              <InformativeAlertPhase
                showCriticalAlert={showCriticalAlert}
                isActiveLoading={isActiveLoading}
              />
            </Mobile>
            <Desktop>
              <VersionedAlertBoxDesktop
                showCriticalAlert={showCriticalAlert}
                isActiveLoading={isActiveLoading}
              />
            </Desktop>
          </>
        )}

        <Desktop>
          <VersionedFormDesktop
            data={data}
            onBlur={onBlur}
            showErrors={showErrors}
            disabledEmail={disabledEmail}
            isActive={isActive}
            userEmail={userEmail}
            isActiveLoading={isActiveLoading}
            formFields={formFields}
          />
        </Desktop>
        <Mobile>
          <PrimeAcquisitionForm
            data={data}
            onBlur={onBlur}
            showErrors={showErrors}
            disabledEmail={disabledEmail}
            isActive={isActive}
            userEmail={userEmail}
            isActiveLoading={isActiveLoading}
            formFields={formFields}
          />
        </Mobile>
      </Card>
    </Box>
  );
};
